<template>
  <div class="w-full space-y-4">
    <template v-if="items && items.length > 0">
      <div v-for="(item, index) in items" :key="index"
        class="w-full border border-gray-300 rounded-xl p-4 cursor-pointer hover:bg-gray-50"
        @click="route ? $router.push(`${route}/${item.id}`) : null">
        <ul class="flex flex-col gap-2">
          <li v-for="field in fields" :key="field.key" class="flex flex-col">
            <template v-if="showOptions && field.key === 'opciones'">
              <div class="flex justify-start gap-3">
                <button v-if="!fileDownload" @click.stop="handleClickOpenModal(item)" title="Elige una Solicitud">
                  <img src="@/assets/img/more.svg" alt="More" class="w-4 hover:scale-110 transition-transform">
                </button>

                <router-link v-if="route && !fileDownload" :to="`${route}/${item.id}`" title="Ver detalles" class="text-inherit no-underline" @click.stop>
                  <img src="@/assets/img/detailIcon.svg" alt="Detail" class="w-6 hover:scale-110 transition-transform" />
                </router-link>

                <button v-if="fileDownload" @click.stop="handleDownload(item)" title="Descargar archivo" class="ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 hover:scale-110 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </button>
              </div>
            </template>
            <div v-else class="flex flex-col gap-1">
              <span class="text-xs font-medium text-[#42A9C2] uppercase">{{ field.label }}</span>
              <span
                v-if="field.key === 'contract_improvement' && item.contract_improvement_accepted_at"
                class="inline-flex w-fit rounded-full bg-[#E2F7FB] px-2 py-1 text-xs font-semibold text-[#147D98]"
              >
                {{ t('contractImprovement.badge') }}
              </span>
              <span v-else class="text-sm text-gray-500">{{ getDisplayValue(item, field.key) }}</span>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <div v-else class="w-full text-center py-8 text-gray-500">
      No hay elementos para mostrar
    </div>
  </div>

  <ModalSelector
    :isOpen="showModal"
    title="Elige una Solicitud"
    :listOptions="listOptions"
    v-model:modelValue="selectedOption"
    :preventRedirect="true"
    @confirm="handleConfirm"
    @close="showModal = false"
  />
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { typeLabel } from '@/services/typeLabels';
import ModalSelector from "../modal/selected-modal.vue";

const { t, te } = useI18n();
const showModal = ref(false);
const selectedOption = ref('');
const selectedItem = ref(null);
const router = useRouter();

defineProps({
  fields: {
    type: Array,
    required: true,
  },
  items: {
    type: Array,
    required: true,
    default: () => []
  },
  showOptions: {
    type: Boolean,
    default: false
  },
  route: {
    type: String,
    default: null
  },
  click: {
    type: Function,
    default: () => { }
  },
  listOptions: {
    type: Array,
    default: () => []
  },
  fileDownload: {
    type: Boolean,
    default: false
  }
});

const handleClickOpenModal = (item) => {
  selectedItem.value = item;
  showModal.value = true;
};

const handleDownload = (item) => {
  // Implement download logic here if needed
  console.log('Download item:', item);
};

// Función para obtener el valor a mostrar, traduciendo los tipos de solicitud
const getDisplayValue = (item, fieldKey) => {
  const value = item[fieldKey];
  
  // Si es el campo "type", traducirlo igual que la tabla de escritorio (puede
  // traer varios valores, como los roles de Usuarios ADS)
  if (fieldKey === 'type' && value) {
    return typeLabel(value, item?.other_action, { t, te });
  }
  
  // Si es el campo "status" y tenemos un valor válido, traducirlo
  if (fieldKey === 'status' && value) {
    return t(`common.requestStatus.${value}`) || value;
  }

  if (fieldKey === 'contract_improvement') {
    return item.contract_improvement_accepted_at ? t('contractImprovement.filter.accepted') : '-';
  }
  
  return value || '-';
};

const handleConfirm = (selectedRoute) => {
  try {
    const item = selectedItem.value || {};
    const userId = item?.property?.owner_id || item?.user_id || item?.owner_id || item?.user?.id || null;
    const userName = item?.property?.owner_name || item?.owner_name || item?.user?.name || '';
    if (selectedRoute) {
      router.push({ path: selectedRoute, query: { user_id: userId, user_name: userName } });
    }
  } finally {
    showModal.value = false;
  }
}
</script>
